export default __webpack_public_path__ + "static/media/arrow2.42143b24.svg";